module.exports = __webpack_public_path__ + "static/media/add-outline.24173324.svg";